/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadWaitlistRankRequest
 */
export interface UpdateLeadWaitlistRankRequest {
    /**
     * 
     */
    current_rank?: number;
    /**
     * 
     */
    new_rank?: number;
    /**
     * 
     */
    comment?: string;
}

/**
 * Check if a given object implements the UpdateLeadWaitlistRankRequest interface.
 */
export function instanceOfUpdateLeadWaitlistRankRequest(value: object): value is UpdateLeadWaitlistRankRequest {
    return true;
}

export function UpdateLeadWaitlistRankRequestFromJSON(json: any): UpdateLeadWaitlistRankRequest {
    return UpdateLeadWaitlistRankRequestFromJSONTyped(json, false);
}

export function UpdateLeadWaitlistRankRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadWaitlistRankRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'current_rank': json['current_rank'] == null ? undefined : json['current_rank'],
        'new_rank': json['new_rank'] == null ? undefined : json['new_rank'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function UpdateLeadWaitlistRankRequestToJSON(json: any): UpdateLeadWaitlistRankRequest {
    return UpdateLeadWaitlistRankRequestToJSONTyped(json, false);
}

export function UpdateLeadWaitlistRankRequestToJSONTyped(value?: UpdateLeadWaitlistRankRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current_rank': value['current_rank'],
        'new_rank': value['new_rank'],
        'comment': value['comment'],
    };
}

